/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
//import _ from 'lodash';
import {FETCH_ORB_STOCK, GET_INCOMING_CARS, VALIDATE_RDW} from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';

export const initialState = {
  ORB: {},
};

export const ORBReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case FETCH_ORB_STOCK: {
            draft.stock = action.result;
          }
          case VALIDATE_RDW: {
            draft.checkInfo = action.result;
          }
          case GET_INCOMING_CARS: {
            const formattedIncoming = {...action.result};
            formattedIncoming.editable = formattedIncoming.items?.map((item, idx) => ({
              id: idx,
              mileage: item?.tellerstandgegevens?.tellerstand,
              noCounter: false,
              useIllogical: false,
              requestCard: false,
              requestReport: true,
              regPlate: item?.voertuig?.kenteken,
              merk: item?.voertuig?.merk,
              model: item?.voertuig?.model,
              rdw: item?.koopintentiegegevens?.rdwbedrijfsnummerkoper,
              company: '-',
              status: item?.laatsteoverdrachtstatus?.statusomschrijving,
              updated: new Date(item?.laatsteoverdrachtstatus?.statusregistratiedatumtijd).toLocaleString('nl-NL'),
            }))
            draft.incoming = formattedIncoming;
          }
        }
    }
  });
};
